/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>language.service.ts</name>
///
/// <description>
///  The mediator service will mediate events between the various UI entities
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>15 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 15Jan17 MM  1.0.0000         First cut 
/// 06Feb17 YH  1.0.0000         Locale strings dictionary
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Component, Injectable} from '@angular/core'; 
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { TranslateI18Next, ILanguageDetector } from 'ngx-i18next/index';
//import { TranslateI18NextLanguagesSupport } from 'ngx-i18next/TranslateI18NextLanguageDetector';

import { HydrogenAppConfigService } from '../host.config.service';

@Injectable()
export class LanguageService implements ILanguageDetector {
    constructor(private configSvc:HydrogenAppConfigService) {}
    detect() {

        let languageAndCountry: string; //For example, en-us
        let language: string;           //For example, en
        try {
            
            var nav: any = window.navigator;
            var client: any = window.clientInformation;
            var ua = nav.userAgent;
            var msie = ua.indexOf("MSIE ");
            var trident = ua.indexOf('Trident/');
            var edge = ua.indexOf('Edge/');
            if (edge > 0 || trident > 0 || msie > 0) {
                languageAndCountry = nav.userLanguage;
                //navigator.browserLanguage - is the OS language http://msdn.microsoft.com/en-us/library/ms533542(VS.85).aspx 
                //navigator.userLanguage - is the language from the Regions Options in the control panelhttp://msdn.microsoft.com/en-us/library/ms534713(VS.85).aspx
                //navigator.systemLanguage
            }
            else {
                languageAndCountry = nav.language;
            }
            //YH 3/22/2017 Bug 122331 - If the language detected in the browser is not supported, the application does not fallback to en - English
            let supportedLanguages : Array<string> = this.configSvc.config.locale.supportedLanguages;
            let isLanguageAndCountySupported = supportedLanguages.indexOf(languageAndCountry.toLocaleLowerCase()) >=0;
            if (isLanguageAndCountySupported) {
                language = languageAndCountry;
            }
            else {
                //Try to see if the language without the county is supported
                language = languageAndCountry.substring(0,2);
                let isLanguageSupported = supportedLanguages.indexOf(language.toLocaleLowerCase()) >=0;
                if (!isLanguageSupported) {
                    language = "en-us";        
                }
            }
        }
        catch (e) {
            language = "en-us";
        } 

        return language;
    }
}

//YH 2/6/2017 
@Injectable()
export class TranslatedStringsService {
     

    constructor(private i18n: TranslateI18Next,
                     private languageDetector: LanguageService) {

        console.debug("TranslatedStringsService constructor");

        //this.init();
      
    }
    
    public init2( ):Promise<void> {
        console.debug("TranslatedStringsService init2()");
        return this.i18n.init({
            debug: false,
            returnEmptyString: false, // optional	- but.. it's important, please see http://i18next.com/docs/options/!
            fallbackLng: 'en-us',
            browserLanguageDetector: this.languageDetector
        });
    }

    public translate( key:string):string {
        return this.i18n.translate(key);
    }
}

@Injectable()
export class TranslatedStringsResolver implements Resolve<any> {
  constructor(private translatedStringsService: TranslatedStringsService, private router: Router) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
      console.debug("TranslatedStringsService TranslatedStringsResolver.resolve()");
    return this.translatedStringsService.init2();
  }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/language.service.ts